import get from 'lodash/get'
import { dateTimeMethod } from '~/mixins/dateTime'

import {
  COURSE_CREATE_POST_QUESTION_ANSWER,
  COURSE_CREATE_POST_QUESTION_REVIEW,
  COURSE_UPDATE_POST_QUESTION_REVIEW,
  INTERNAL_COURSE_ENROLL_UPDATE,
} from '~/graphql/mutations/course'
import { UPDATE_COURSE_VERIFICATION } from '~/graphql/mutations/courseVerification'

const actionTypes = {
  FETCH_COURSE_DETAIL: 'FETCH_COURSE_DETAIL',
  COURSE_CREATE_POST_QUESTION_ANSWER: 'COURSE_CREATE_POST_QUESTION_ANSWER',
  COURSE_CREATE_POST_QUESTION_REVIEW: 'COURSE_CREATE_POST_QUESTION_REVIEW',
  COURSE_UPDATE_POST_QUESTION_REVIEW: 'COURSE_UPDATE_POST_QUESTION_REVIEW',
  UPDATE_COURSE_VERIFICATION: 'UPDATE_COURSE_VERIFICATION',
  INTERNAL_COURSE_ENROLL_UPDATE: 'INTERNAL_COURSE_ENROLL_UPDATE',
}

const mutationTypes = {
  SET_FETCHING_COURSE_DETAIL: 'SET_FETCHING_COURSE_DETAIL',
  SET_ACADEMY_COURSE: 'SET_ACADEMY_COURSE',
}
export const state = () => ({
  fetchingCourseDetail: false,
  scheduleInfo: {
    course: {},
    user: {},
    approver: {},
  },
})
export const mutations = {
  [mutationTypes.SET_FETCHING_COURSE_DETAIL](state, fetchingCourseDetail) {
    state.fetchingCourseDetail = fetchingCourseDetail
  },
  [mutationTypes.SET_ACADEMY_COURSE](state, scheduleInfo) {
    scheduleInfo.course.scheduleClasses.forEach((schedule) => {
      schedule.endDatetime = dateTimeMethod.utcToDate(schedule.endDatetime)
      schedule.startDatetime = dateTimeMethod.utcToDate(schedule.startDatetime)
    })
    state.scheduleInfo = scheduleInfo
  },
}

export const actions = {
  async [actionTypes.FETCH_COURSE_DETAIL]({ commit, dispatch }, { slug, needLoading = true }) {
    if (needLoading) {
      commit(mutationTypes.SET_FETCHING_COURSE_DETAIL, true)
    }
    try {
      const { success, data } = await dispatch('schedule/ACADEMY_SCHEDULE_INFO', slug, { root: true })
      let ids = []
      if (success && data.academyScheduleInfo) {
        commit(mutationTypes.SET_ACADEMY_COURSE, {
          ...data.academyScheduleInfo,
          course: data.academyScheduleInfo.course,
        })
        ids = get(data.academyScheduleInfo, 'course.courseEnrolls', []).map((enrol) => enrol.userId)
      } else {
        const { data: courseData } = await dispatch('course/GET_ACADEMY_COURSE_INFO', slug, { root: true })
        commit(mutationTypes.SET_ACADEMY_COURSE, { course: courseData.academyCourse })
        ids = courseData.academyCourse.courseEnrolls.map((enrol) => enrol.userId)
      }
      await dispatch('usersInfo/GET_USERS_INFO', { userIds: ids }, { root: true })
      if (needLoading) {
        commit(mutationTypes.SET_FETCHING_COURSE_DETAIL, false)
      }
      return { success: true }
    } catch (error) {
      console.error('error', error)
      if (needLoading) {
        commit(mutationTypes.SET_FETCHING_COURSE_DETAIL, false)
      }
      return { error, success: false }
    }
  },
  async [actionTypes.INTERNAL_COURSE_ENROLL_UPDATE]({}, params) {
    try {
      const apolloClient = this.app.apolloProvider.defaultClient

      const { data } = await apolloClient.mutate({
        mutation: INTERNAL_COURSE_ENROLL_UPDATE,
        variables: params,
      })
      return {
        data,
        success: true,
      }
    } catch (error) {
      console.error(`store/${actionTypes.INTERNAL_COURSE_ENROLL_UPDATE}`, error)
      return {
        error,
        success: false,
      }
    }
  },
  async [actionTypes.COURSE_CREATE_POST_QUESTION_ANSWER]({ state, commit }, answers) {
    try {
      const apolloClient = this.app.apolloProvider.defaultClient
      const { data } = await apolloClient.mutate({
        mutation: COURSE_CREATE_POST_QUESTION_ANSWER,
        variables: { answers },
      })
      return {
        data,
        success: true,
      }
    } catch (error) {
      return {
        error,
        success: false,
      }
    }
  },
  async [actionTypes.COURSE_CREATE_POST_QUESTION_REVIEW]({ state, commit }, review) {
    try {
      const apolloClient = this.app.apolloProvider.defaultClient
      const { data } = await apolloClient.mutate({
        mutation: COURSE_CREATE_POST_QUESTION_REVIEW,
        variables: { review },
      })
      return {
        data,
        success: true,
      }
    } catch (error) {
      return {
        error,
        success: false,
      }
    }
  },
  async [actionTypes.COURSE_UPDATE_POST_QUESTION_REVIEW]({ state, commit }, review) {
    try {
      const apolloClient = this.app.apolloProvider.defaultClient
      const { data } = await apolloClient.mutate({
        mutation: COURSE_UPDATE_POST_QUESTION_REVIEW,
        variables: { review },
      })
      return {
        data,
        success: true,
      }
    } catch (error) {
      return {
        error,
        success: false,
      }
    }
  },
  async [actionTypes.UPDATE_COURSE_VERIFICATION]({}, params) {
    try {
      const apolloClient = this.app.apolloProvider.defaultClient
      const { data } = await apolloClient.mutate({
        mutation: UPDATE_COURSE_VERIFICATION,
        variables: params,
      })
      return {
        data: data.academyUpdateVerifyCourseRequest,
        success: true,
      }
    } catch (error) {
      return {
        error,
        success: false,
      }
    }
  },
}

export const getters = {
  fetchingCourseDetail: (state) => state.fetchingCourseDetail,
  academyCourse: (state, getters) => {
    return { ...state.scheduleInfo, ...getters.course }
  },
  course: (state) => {
    const {
      completedOnSchedule,
      course,
      status,
      topicEnrolls,
      completedAt,
      id,
      startDate,
      class: classInfo,
      minutesPerDay,
    } = state.scheduleInfo
    return {
      ...course,
      scheduleStatus: status,
      topicEnrolls,
      completedOnSchedule,
      completedAt,
      enrollId: id,
      enrollStartDate: startDate,
      minutesPerDay,
      classInfo,
    }
  },
  user: (state) => state.scheduleInfo.user,
  approver: (state) => state.scheduleInfo.approver,
}
